import axios from 'axios';
import {server} from '../../../../lib/server';

const jwtAxios = axios.create({
  baseURL: server, //YOUR_API_URL HERE
  // baseURL: "https://crema-mongo-api.herokuapp.com/api/", //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
});

jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.msg === 'Token is not valid') {
      console.log('Need to logout user');
      // store.dispatch({type: LOGOUT});
    }
    return Promise.reject(err);
  },
);
export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common['authorization'] = `Bearer ${token}`;
    localStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['authorization'];
    localStorage.removeItem('token');
  }
};

export default jwtAxios;
